/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Organization } from './Organization';
// @ts-ignore
import {
// @ts-ignore
    OrganizationFromJSON,
// @ts-ignore
    OrganizationFromJSONTyped,
// @ts-ignore
    OrganizationToJSON,
} from './Organization';

/**
 * 
 * @export
 * @interface OrganizationListResponse
 */
export interface OrganizationListResponse {
    /**
     * 
     * @type {number}
     * @memberof OrganizationListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Organization>}
     * @memberof OrganizationListResponse
     */
    items: Array<Organization>;
}

/**
 * Check if a given object implements the OrganizationListResponse interface.
 */
// @ts-ignore
export function instanceOfOrganizationListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function OrganizationListResponseFromJSON(json: any): OrganizationListResponse {
    return OrganizationListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function OrganizationListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(OrganizationFromJSON)),
    };
}

// @ts-ignore
export function OrganizationListResponseToJSON(value?: OrganizationListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(OrganizationToJSON)),
    };
}

